
import { Options, Vue } from "vue-class-component";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { PusatResolusiSTT } from "@/domain/entities/PusatResolusiV2";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ListSTTPusatResolusi } from '@/data/payload/api/PusatResolusiV2ApiRequest';

@Options({
  emits: ["select"]
})
export default class CardSTT extends Vue {
  private scrollAmount = 300;
  public showLeftButton = false;
  public showRightButton = true;
  private currentPage = 1;
  private isLoading = false;
  private hasMoreData = true;

  public mounted() {
    this.updateNavigationButtons();
    this.getSTTList();
  }

  public updateNavigationButtons() {
    const container = this.$refs.cardContainer as HTMLElement;
    if (container) {
      this.showLeftButton = container.scrollLeft > 0;
      this.showRightButton =
        container.scrollLeft < container.scrollWidth - container.clientWidth;
    }
  }

  get dataSTT(): PusatResolusiSTT[] {
    return PusatResolusiV2Controller.lastSttOrShipmentNoList;
  }
 

  private shouldLoadMoreData(isRight: boolean, newScrollPosition: number, maxScroll: number): boolean {
    return isRight && 
           newScrollPosition >= maxScroll * 0.8 && 
           !this.isLoading && 
           this.hasMoreData;
  }

  public scrollRight(isRight = true) {
    const container = this.$refs.cardContainer as HTMLElement;
    if (container) {
      const maxScroll = container.scrollWidth - container.clientWidth;
      const newScrollPosition = isRight
        ? Math.min(container.scrollLeft + this.scrollAmount, maxScroll)
        : Math.max(container.scrollLeft - this.scrollAmount, 0);

      container.scrollTo({
        left: newScrollPosition,
        behavior: "smooth"
      });

      if (this.shouldLoadMoreData(isRight, newScrollPosition, maxScroll)) {
        this.loadMoreData();
      }

      setTimeout(() => {
        this.updateNavigationButtons();
      }, 500);
    }
  }

  onSelectStt(item: PusatResolusiSTT) {
    this.$emit("select", item);
  }
  
  private async loadMoreData() {
    this.currentPage++;
    await this.getSTTList(false);
  }

  async getSTTList(reset = true) {
    if (this.isLoading) return;

    try {
      this.isLoading = true;
      if (reset) {
        this.currentPage = 1;
        MainAppController.showLoading();
      }

      const getData = await PusatResolusiV2Controller.getSTTList({
        params: new ListSTTPusatResolusi({
          page: this.currentPage,
          limit: 20
        })
      });

      if (reset) {
        PusatResolusiV2Controller.setLastSttOrShipmentNoList(getData.data);
      } else {
        // Append new data to existing list
        PusatResolusiV2Controller.setLastSttOrShipmentNoList([
          ...PusatResolusiV2Controller.lastSttOrShipmentNoList,
          ...getData.data
        ]);
      }

      // Check if we have more data
      this.hasMoreData = getData.data.length === 20;

      this.$nextTick(() => {
        this.updateNavigationButtons();
      });
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Gagal mengambil data STT!")
      );
    } finally {
      this.isLoading = false;
      if (reset) {
        MainAppController.closeLoading();
      }
    }
  }
}
